import React, { Component } from 'react';

// import { Button } from 'antd';

import './index.scss';
import utils from '../../common/utils';

import { createHashHistory } from 'history'

class Exception extends Component {
  constructor(props, context){
    super(props)
    this.state ={
      errorCode:404
    }
    this.exceptionInfo = {
      404:{
        description:'抱歉，你访问的页面不存在',
        back:'返回首页',
        imageUrl:'https://shared.ydstatic.com/sw/404.png'
      },
      406:{
        description:'抱歉，当前账号没有权限，请联系管理员',
        back:'返回首页',
        imageUrl:'https://shared.ydstatic.com/sw/404.png'
      },
      500:{
        description:'抱歉，服务器出错了',
        back:'返回首页',
        imageUrl:'https://gw.alipayobjects.com/zos/rmsportal/RVRUAYdCGeYNBWoKiIwB.svg'
      }
    }
  }
  componentWillReceiveProps(nextProps) {
  }
  componentDidMount(){
    var me = this;
    me.errorCode = utils.getParamsByHash() ;
    this.setState({
      errorCode:me.errorCode||404
    })
  }
  back(){
    createHashHistory().push('/');
  }
  render() {
    var expText = this.exceptionInfo[this.state.errorCode] ;
    return (
      <div className="Exception">
        <div className="imgBlock"><img src={expText.imageUrl} /></div>
        <div className="exceptionContent">
          <h1>{this.state.errorCode}</h1>
          <div className="desc">{expText.description}</div>
          <div className="actions">
            {/* <Button type="primary" onClick={this.back}>{expText.back}</Button> */}
          </div>
        </div>
      </div>
    );
  }
}

export default Exception;
